import { useMemo } from 'react';
import { useEvents } from './useEvents';

/**
 * Hook to detect if there's a live race in progress for a given league type
 * Returns the event if a race is live, otherwise null
 * 
 * This hook derives from useEvents to avoid duplicate API calls and caching.
 * No polling - relies on useEvents cache which has a 5-minute stale time.
 */
export function useLiveRaceEvent(leagueTypeId: string | undefined) {
  const { data: events = [], isLoading, error } = useEvents(leagueTypeId);

  const liveEvent = useMemo(() => {
    return events.find(event => event.status === 'in_progress') ?? null;
  }, [events]);

  return {
    data: liveEvent,
    isLoading,
    error,
  };
}